import { action, observable } from "mobx";

class Notification {
    id: number;
    message: string;
    level: NotificationLevel;
    dateCreate: Date;
    onRemoveCallback?: () => void;

    constructor(message: string, level: NotificationLevel, id: number, onRemoveCallback?: () => void) {
        this.message = message;
        this.level = level;
        this.dateCreate = new Date();
        this.id = id;
        this.onRemoveCallback = onRemoveCallback;
    }
}

export enum NotificationLevel {
    warning,
    info,
    error,
    success
}

export class NotificationStore {

    @observable notificationId: number = new Date().getTime();

    @observable notifications: Notification[] = [];

    @action
    addNotification(message: string, level: NotificationLevel, autoDismiss = 5, onRemoveCallback?: () => void) {
        const notification = new Notification(message, level, this.notificationId++, onRemoveCallback);
        this.notifications.push(notification);
        if (autoDismiss > 0) {
            setTimeout(() => {
                this.removeNotification(notification.id);
            }, autoDismiss * 1000);
        }
    }

    @action
    removeNotification(id: number) {
        this.notifications.filter(w => w.id == id).forEach((not) => {
            if (not.onRemoveCallback != undefined)
                not.onRemoveCallback();
        });
        this.notifications = this.notifications.filter(w => w.id != id);
    }

}